import React, { useEffect, useState } from 'react';
import { useLocation,useHistory } from 'react-router-dom';


import { checkCouponCode} from "./../services";

import { Spin,Result,Button,Badge } from 'antd';

import {GiftOutlined,LoadingOutlined,ArrowRightOutlined,CheckCircleOutlined,StopOutlined} from '@ant-design/icons';


const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 80,
        color:"#FA9E24"
      }}
      spin
    />
  );

const Coupon = () => {
  const location = useLocation();
  const [couponCode, setCouponCode] = useState(null);
  const [couponStatus, setCouponStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const history = useHistory();


  // Function to fetch the coupon code validity
  const verifyCoupon = async (code) => {
    try {
      const response = await checkCouponCode(code);

     
    const  couponState= response.status==="success" ? true : false;
      setCouponStatus(couponState);

      localStorage.setItem("coupon_code",code);
      localStorage.setItem("coupon_valid",couponState);

    //   localStorage.href=""

      history.push('/dashboard');


    } catch (error) {
      setCouponStatus('Error verifying coupon');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Extract query params
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('coupon_code');

    if(searchParams.get('gift_share')){
      
    }

    console.log(code);

    if (code) {
      setCouponCode(code);
      // Verify the coupon on load
      verifyCoupon(code);

    } else {
      setCouponStatus('No coupon code provided');
      setLoading(false);
    }

  }, [location.search]);

  return (
    <div  className="common-page" >


<div className='gift_container'>

    

<div className='inner_block'>

         {loading && <Spin indicator={antIcon}  /> }   
         
<Result
        icon={ <Badge count={ (couponStatus  ? <CheckCircleOutlined style={{ fontSize:"35px",color: 'green' }} /> : <StopOutlined style={{ fontSize:"35px",color: 'red' }} />) }><GiftOutlined style={{fontSize:"80px", color:"#FA9E24"}} /></Badge>}
    status="success"
    title={
        (loading ? "Validating and redeeming the coupons" : (couponStatus ? "Coupon Code Vaild" : "Coupon Code Invaild" )  )
    }
    subTitle={<> Coupon : <b style={{color: (loading ? "#FA9E24" : (couponStatus ? "green" : "red" )  )  }}>{couponCode} </b> 100% Off </>}
    extra={
        (couponStatus ?  [
      
            <Button key="buy">May be Later</Button>,
            <Button type="primary" key="console">
               Redeem Gift  &nbsp;<ArrowRightOutlined />
            </Button>
      
          ] : [  <Button type="primary" key="console">
            Goto Home Page  &nbsp;<ArrowRightOutlined />
          </Button>])
       }
  />
  </div>
  </div>
 

     
      {/* {loading ? (
         <div style={{ "textAlign": "center"}}>
            <Spin indicator={antIcon}  />
         </div>

      ) : (
       ""

       
      )} */}
    </div>
  );
};

export default Coupon;
